import { Web3Address } from '../../common';
import { IGoogleSecretCodeParams } from '../googleOauth';

export enum OauthLoginProvider {
  Auth0 = 'auth0',
  Web3 = 'web3',
  Github = 'github',
  Google = 'google',
  Microsoft = 'microsoft',
  Slack = 'slack',
  Telegram = 'telegram',
  X = 'x',
}

export interface IOauthLoginParams {
  provider: OauthLoginProvider;
  redirectUrl?: string; // use this param to override default redirect URL
}

export interface AssociatedAccount {
  address?: Web3Address;
  email?: string;
  externalId: string;
  login?: string;
  provider: OauthLoginProvider;
  canUnbind?: boolean; // if false unbinding is disabled
  canUnbindReason?: string; // reason why unbinding is disabled
}

export interface IOauthSecretCodeParams extends IGoogleSecretCodeParams {
  provider?: OauthLoginProvider;
}

export interface IUnbindLoginProviderParams {
  provider: OauthLoginProvider;
}

export interface AvailableLoginProviders {
  availableProviders: {
    apple: boolean;
    auth0: boolean;
    github: boolean;
    google: boolean;
    microsoft: boolean;
    slack: boolean;
    telegram: boolean;
    wechat: boolean;
    x: boolean;
  };
  canBind: boolean;
}
